export default [
  {
    text: "Personnel Requisition",
    value: "PR"
  },
  {
    text: "Employee Clearance",
    value: "EC"
  }
];
